import React, { useEffect, useState } from 'react';
import { Quote } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders an approved-quote block for a product page. Hidden when no
 * testimonials have been added yet — no fake quotes, no placeholder text
 * (per brief section 59: "Do not invent testimonials").
 */
const TestimonialBlock = ({ product }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/testimonials?product=${encodeURIComponent(product)}`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setItems)
      .catch(() => setItems([]));
  }, [product]);

  if (!items || items.length === 0) return null;

  return (
    <section className="py-16 md:py-20" data-testid={`testimonials-${product}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">In practitioners&rsquo; own words</p>
        <div className={`grid gap-6 ${items.length > 1 ? 'md:grid-cols-2' : ''}`}>
          {items.map((t) => (
            <figure key={t.id} className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8" data-testid={`testimonial-${t.id}`}>
              <Quote className="w-6 h-6 text-blue-500/80 mb-3" />
              <blockquote className="text-lg text-slate-800 leading-relaxed">&ldquo;{t.quote}&rdquo;</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-slate-100">
                <p className="text-sm font-medium text-slate-900">{t.attribution}</p>
                {t.org && <p className="text-xs text-slate-500 mt-0.5">{t.org}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialBlock;
